import AuthReducer from './AuthReducer'
import UserReducer from './UserReducer'
import InfluencerReducer from './InfluencerReducer'
import { combineReducers } from 'redux'

let appReducer = combineReducers({
  AuthReducer: AuthReducer,
  UserReducer: UserReducer,
  InfluencerReducer: InfluencerReducer,
})

const rootReducer = (state, action) => {
  return appReducer(state, action)
}

export default rootReducer
